import React, { useEffect, useState } from 'react';

const scoreColor = (score) =>
  score >= 90 ? 'var(--score-green)' : score >= 80 ? 'var(--score-amber)' : 'var(--score-red)';

const ScoreGauge = ({ score = 0, size = 120, strokeWidth = 8 }) => {
  const [animated, setAnimated] = useState(0);
  const r = size / 2 - strokeWidth - 2;
  const circumference = 2 * Math.PI * r;
  const color = scoreColor(score);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(score), 100);
    return () => clearTimeout(t);
  }, [score]);

  const offset = circumference - (animated / 100) * circumference;

  return (
    <svg width={size} height={size} className="score-gauge-svg">
      {/* Track */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="rgba(255,255,255,0.07)"
        strokeWidth={strokeWidth}
      />
      {/* Fill */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset 1s ease-out' }}
      />
      {/* Score number */}
      <text
        x={size / 2}
        y={size / 2 - 7}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={color}
        fontSize={size >= 120 ? 26 : 20}
        fontWeight="700"
        fontFamily="var(--font-ui)"
      >
        {score}
      </text>
      {/* /100 label */}
      <text
        x={size / 2}
        y={size / 2 + 13}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="var(--text-tertiary)"
        fontSize="10"
        fontFamily="var(--font-ui)"
      >
        /100
      </text>
    </svg>
  );
};

export default ScoreGauge;
